<template>
  <div id="app">
    <Head :class="getClass()"></Head>
    <router-view></router-view>
    <Footer></Footer>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import Head from "@/components/Head";
import Footer from "@/components/Footer";
export default {
  components: {
    Head,
    Footer,
  },
  data() {
    return {};
  },
  created() {
    this.setRem();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.setRem();
    });
  },
  methods: {
    setRem() {
      var docEl = document.documentElement;
      var screenWidth = docEl.clientWidth || window.screen.width || 1360;
      docEl.style.fontSize = (100 * screenWidth) / 1920 + "px";
    },
    getClass() {
      if (this.$route.path == "/") {
        return "index-header";
      } else if (
        this.$route.path == "/projectIndex" ||
        this.$route.path == "/companyInfo" ||
        this.$route.path == "/teacherInfo" ||
        this.$route.path == "/companyIntroduce" ||
        this.$route.path == "/testCenter" ||
        this.$route.path == "/recruitIndex" ||
        this.$route.path == "/courseList"
      ) {
        return "project-header";
      }
      return "";
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/style/common.scss";
@import "~@/assets/font/iconfont.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #222222;
}
.el-backtop {
  z-index: 51 !important;
  color: #0038eb !important;
}
</style>
